module.exports = __webpack_public_path__ + "img/PSP_settled.be8b47ab.svg";